import { strlen } from "@/utilities/common";
import { AgencyType } from "@/utilities/common_enum";

export const validateTextField = (
  value: string,
  required: boolean,
  minLength: number,
  maxLength: number | undefined
) => {
  if (required) {
    if (minLength <= 0) {
      minLength = 0;
    }
    if (strlen(value) < minLength) {
      return false;
    }
  }

  return maxLength === undefined || strlen(value) <= maxLength;
};

export const LeadGenVerifyDomain = (domain: any) => {
  // eslint-disable-next-line no-useless-escape
  let reg = /^[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&%'\*\+,;=.]+$/i;
  return reg.test(domain);
};

export const findValue = (arr: any, id: any) => {
  return arr?.find((item: any) => Number(item.key) === Number(id));
};

export const isLeadGenAgency = (agency: number) => {
  return agency === AgencyType.LeadGen;
};
